import { createContext } from "react";

const DF_OT0055Context = createContext();

export { DF_OT0055Context };
